import { SessionCallStates } from "./sessionSlice.types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchSession } from "./sessionThunk";
import { SessionResponse } from "api/controlPlaneApi";

export type SessionStates = "unchecked" | "valid" | "invalid";

export interface SessionState {
  session: SessionResponse;
  sessionLoadingState: SessionCallStates;
  sessionState: SessionStates;
}

const initialState: SessionState = {
  session: {},
  sessionLoadingState: SessionCallStates.Initial,
  sessionState: "unchecked",
};

export const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setSessionLoadingState: (
      state,
      action: PayloadAction<SessionCallStates>,
    ) => {
      state.sessionLoadingState = action.payload;
    },
    saveSessionResponse: (state, action: PayloadAction<SessionResponse>) => {
      state.session = action.payload;
    },
    resetSession: (state) => {
      state.session = initialState.session;
    },
    setSessionState: (state, action: PayloadAction<SessionStates>) => {
      state.sessionState = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSession.pending, (state, action) => {
        state.sessionLoadingState = SessionCallStates.Loading;
      })
      .addCase(fetchSession.fulfilled, (state, action) => {
        state.sessionLoadingState = SessionCallStates.Done;
      })
      .addCase(fetchSession.rejected, (state, action) => {
        state.sessionLoadingState = SessionCallStates.Done;
      });
  },
});

export const {
  saveSessionResponse,
  resetSession,
  setSessionLoadingState,
  setSessionState,
} = sessionSlice.actions;
export default sessionSlice.reducer;
